import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIcon,
  ],
})
export class ChangePasswordDialogComponent implements OnInit {
  protected fb = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<ChangePasswordDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  passwordForm: UntypedFormGroup;

  constructor() {
    this.passwordForm = this.fb.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      repeat: ['', Validators.compose([Validators.required])],
      valid: [false, Validators.requiredTrue],
    });
  }

  ngOnInit(): void {
    this.listenForm();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private listenForm() {
    this.passwordForm.valueChanges.subscribe(data => {
      let valid: boolean = false;
      if (data['password'] == data['repeat']) valid = true;
      else valid = false;

      this.passwordForm.patchValue({ valid: valid }, { emitEvent: false });
    });
  }
}
